// Company Information

import asianPearlTrading from '../assets/images/Asian Pearl Trading WLL (Bahrain).png';
import friendsFood from '../assets/images/Friends-Food-logo.png';
import alYousuf from '../assets/images/al-yousuf.png';
import alabeerColdstore from '../assets/images/Alabeer-Coldstore-(KSA).png';
import heroImage from '../assets/images/hero.png';
import aims from '../assets/images/projects/AIMS Square Jeddah LULU market.jpg.jpeg';
import kccMadina from '../assets/images/projects/KEC - MADINAH HUB.webp';
import kccHilton from '../assets/images/projects/KEC- Hilton Hotel and Hilton-Branded Residences.jpg.jpeg';
import taiba from '../assets/images/projects/Taiba University Madinah.jpg.jpeg';
import theArab from '../assets/images/projects/the-Arab-Hospital-project Jeddah.jpg.jpeg';

export const companyInfo = {
  name: 'Al Abeer Diamond Company LLC',
  shortName: 'Al Abeer Diamond Company LLC.',
  tagline: 'Building Excellence, Ensuring Safety',
  description: 'Al Abeer Diamond Company LLC is a leading multi-disciplinary company based in Saudi Arabia, providing high-quality solutions in construction, technical works, manpower supply, and cleaning solutions.',
  email: 'Contact@alabeerdiamondllc.com',
  phone1: '+966 53 522 1070',
  phone2: '+966 50 557 3077',
  address: 'Old Makkah road, Dist. Al Mursalat, Jeddah KSA',
  website: 'www.alabeerdiamondllc.com',
  established: 2024,
};

// Navigation Links
export const navLinks = [
  { id: 1, title: 'Home', href: '/' },
  { id: 2, title: 'About Us', href: '/about' },
  { id: 3, title: 'Services', href: '/services' },
  { id: 4, title: 'Projects', href: '/projects' },
  { id: 5, title: 'Contact', href: '/contact' },
];

// Social Links
export const socialLinks = [
  { id: 1, icon: 'uil uil-facebook-f', url: 'https://facebook.com' },
  { id: 2, icon: 'uil uil-linkedin', url: 'https://linkedin.com' },
  { id: 3, icon: 'uil uil-twitter', url: 'https://twitter.com' },
  { id: 4, icon: 'uil uil-instagram', url: 'https://instagram.com' },
  { id: 5, icon: 'uil uil-youtube', url: 'https://youtube.com' },
];

// Useful Links (Footer)
export const usefulLinks = [
  { id: 1, title: 'About Us', url: '/about' },
  { id: 2, title: 'Our Services', url: '/services' },
  { id: 3, title: 'Our Projects', url: '/projects' },
  { id: 4, title: 'Contact Us', url: '/contact' },
  { id: 5, title: 'Careers', url: '/careers' },
];

// Hero Content
export const heroContent = {
  headline: 'Building Excellence, Ensuring Safety',
  subHeadline: 'Leading Multi-Disciplinary Company in Saudi Arabia',
  description: 'We deliver high-quality construction, technical works, manpower supply, and cleaning solutions with innovation and reliability.',
  buttonText: 'Discover More',
  buttonUrl: '/about',
  bgImage: heroImage,
};

// About Content
export const aboutContent = {
  heading: 'Welcome to Al Abeer Diamond',
  description: 'With a strong foundation built on technical excellence and customer-focused service, Al Abeer Diamond Company LLC has evolved into a comprehensive solutions provider for industrial, commercial, and infrastructure projects.',
  description2: 'Over the years, we have broadened our capabilities to meet the diverse needs of Saudi Arabia\'s rapidly growing market—expanding our services, upgrading our technologies, and strengthening our workforce.',
  description3: 'Today, Al Abeer stands as a trusted partner committed to delivering sustainable, high-performance solutions that align with the Kingdom\'s development goals and contribute to building a stronger, smarter future for generations to come.',
  image: '/img/about-us.webp',
  stats: [
    { number: '50+', label: 'Years Combined Experience' },
    { number: '1500+', label: 'Satisfied Clients' },
    { number: '200+', label: 'Expert Team Members' },
    { number: '100+', label: 'Global Premium Clients' },
  ],
};

// Why Choose Data
export const whyChooseData = [
  {
    id: 1,
    title: 'Excellence',
    description: 'We are committed to delivering the highest standards of workmanship, materials, and service across all our operations.',
    icon: 'uil uil-trophy',
  },
  {
    id: 2,
    title: 'Innovation',
    description: 'We embrace modern technologies, advanced methods, and smart solutions to enhance efficiency and achieve superior project outcomes.',
    icon: 'uil uil-lightbulb',
  },
  {
    id: 3,
    title: 'Integrity',
    description: 'We conduct every project with honesty, transparency, and accountability, ensuring trust and long-term partnerships with our clients.',
    icon: 'uil uil-shield-check',
  },
  {
    id: 4,
    title: 'Reliability',
    description: 'We believe in delivering on our promises on time, within budget, and with consistent performance across all projects.',
    icon: 'uil uil-clock',
  },
];

// Services Data
export const servicesData = [
  {
    id: 1,
    title: 'Civil & Construction',
    icon: 'uil uil-constructor',
    image:
      'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=80',
    description:
      'Building solutions from foundation to final completion with premium materials and skilled craftsmanship.',
    features: [
      'Building Construction & Finishing',
      'Structural Concrete & Steel Works',
      'Roads, Utilities & Infrastructure',
      'Excavation & Earthworks',
      'Renovation & Maintenance',
    ],
  },

  {
    id: 2,
    title: 'Electrical Works',
    icon: 'uil uil-bolt',
    image:
      'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1200&q=80',
    description:
      'Safe and reliable electrical solutions for residential, commercial, and industrial projects.',
    features: [
      'HV, MV, and LV Systems',
      'Substation and Power Plant Works',
      'Transmission and Distribution',
      'Lighting and Power Installation',
      'Control Systems & Automation',
      'Fire Alarm & Detection Systems',
    ],
  },

  {
    id: 3,
    title: 'Mechanical Works',
    icon: 'uil uil-cog',
    image:
      'https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=1200&q=80',
    description:
      'Comprehensive mechanical solutions designed to support residential, commercial, and industrial facilities.',
    features: [
      'HVAC Installation & Maintenance',
      'Plumbing & Drainage Systems',
      'Fire Fighting Systems',
      'Piping, Welding & Fabrication',
      'Steel Structure Works',
    ],
  },

  {
    id: 4,
    title: 'Manpower Supply',
    icon: 'uil uil-users-alt',
    image:
      'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=80',
    description:
      'Reliable and skilled manpower solutions to support projects across all construction and industrial sectors.',
    features: [
      'Engineers (Electrical, Mechanical, Civil, HSE)',
      'Project Managers & Supervisors',
      'Skilled Technicians',
      'General Workforce',
    ],
  },

  {
    id: 5,
    title: 'Heavy Machinery Rental',
    icon: 'uil uil-truck',
    image:
      'https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=1200&q=80',
    description:
      'Modern, fully serviced fleet of heavy machinery for construction, industrial, and infrastructure projects.',
    features: [
      'Excavators',
      'Loaders',
      'Cranes',
      'Bulldozers',
      'Forklifts & Specialized Equipment',
    ],
  },

  {
    id: 6,
    title: 'Cleaning Solutions',
    icon: 'uil uil-brush',
    image:
      'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1200&q=80',
    description:
      'Comprehensive cleaning solutions for commercial, industrial, and residential facilities.',
    features: [
      'General Cleaning Services',
      'Deep Cleaning & Disinfection',
      'Post-Construction Cleaning',
      'Industrial Cleaning',
      'Floor Care & Polishing',
      'Glass & Facade Cleaning',
    ],
  },
];

// ============================================
// ADD THESE MISSING EXPORTS
// ============================================

// Projects Data
export const projectsData = [
  {
    id: 1,
    title: 'AIMS Square Jeddah - Lulu Market',
    category: 'Construction',
    image: aims,
    description:
      'A major commercial development in Jeddah featuring a Lulu Market and modern retail infrastructure.',
  },
  {
    id: 2,
    title: 'KEC Madinah Hub',
    category: 'Construction',
    image: kccMadina,
    description:
      'A large-scale development project in Madinah designed to support modern commercial and infrastructure requirements.',
  },
  {
    id: 3,
    title: 'KEC Hilton Hotel & Hilton-Branded Residences',
    category: 'Construction',
    image: kccHilton,
    description:
      'A premium hospitality and residential development featuring Hilton Hotel and Hilton-branded residences.',
  },
  {
    id: 4,
    title: 'Taiba University Madinah',
    category: 'Construction',
    image: taiba,
    description:
      'A major educational development project at Taiba University in Madinah.',
  },
  {
    id: 5,
    title: 'The Arab Hospital Project',
    category: 'Construction',
    image: theArab,
    description:
      'A major development project demonstrating high-quality construction and project execution capabilities.',
  },
];

// Project Stats - ADD THIS
export const projectStats = [
  { id: 1, number: '1500+', label: 'Completed Projects' },
  { id: 2, number: '200+', label: 'Qualified Team Members' },
  { id: 3, number: '15+', label: 'Industry Awards' },
  { id: 4, number: '50+', label: 'Years Experience' },
  { id: 5, number: '100+', label: 'Global Clients' },
];

// Stats Data (alias) - ADD THIS
export const statsData = [
  { id: 1, number: '1500+', label: 'Completed Projects' },
  { id: 2, number: '200+', label: 'Qualified Team Members' },
  { id: 3, number: '15+', label: 'Industry Awards' },
  { id: 4, number: '50+', label: 'Years Experience' },
  { id: 5, number: '100+', label: 'Global Clients' },
];

// Testimonials Data - ADD THIS (fixed spelling)
export const testimonialsData = [
  {
    id: 1,
    name: 'Mohammed Al-Faisal',
    position: 'Project Director, Saudi Development Fund',
    text: 'Al Abeer Diamond demonstrated exceptional professionalism and expertise in delivering our infrastructure project. Their commitment to quality and safety was outstanding.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ahmed Al-Ghamdi',
    position: 'CEO, Al-Ghamdi Group',
    text: 'We have partnered with Al Abeer Diamond on multiple projects and have always been impressed by their reliability, technical excellence, and timely delivery.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Sarah Al-Otaibi',
    position: 'Facility Manager, Riyadh Medical Center',
    text: 'The cleaning solutions provided by Al Abeer Diamond have transformed our facility. Their attention to detail and professional approach is commendable.',
    rating: 5,
  },
];

// Group Companies - ADD THIS
// src/data.js (or wherever your data file is)


export const groupCompanies = [
  {
    name: 'Asian Rose General Trading L.L.C. (UAE)',
    logo: asianPearlTrading,
  },
  {
    name: 'Friends Food Export Co. (Pakistan)',
    logo: friendsFood,
  },
  {
    name: 'Pt. Yousuf Alkarim Global (Indonesia)',
    logo: alYousuf,
  },
  {
    name: 'Asian Pearl Trading WLL (Bahrain)',
    logo: asianPearlTrading,
  },
  {
    name: 'Alabeer Coldstore (KSA)',
    logo: alabeerColdstore,
  },
  {
    name: 'Asian Pearl Processing Co. L.L.C (KSA)',
    logo: asianPearlTrading,
  },
  {
    name: 'Asian Pearl Myanmar Co. Ltd. (Myanmar)',
    logo: asianPearlTrading,
  },
  {
    name: 'Asian Pearl Private Company LTD (Thailand)',
    logo: asianPearlTrading,
  },
];

// Certification Data - ADD THIS
export const certificationData = [
  { id: 1, title: 'ISO 9001:2015 Quality Management', icon: 'uil uil-award' },
  { id: 2, title: 'ISO 14001:2015 Environmental Management', icon: 'uil uil-leaf' },
  { id: 3, title: 'OHSAS 18001 Health & Safety', icon: 'uil uil-shield-check' },
  { id: 4, title: 'Saudi Aramco Approved Contractor', icon: 'uil uil-building' },
];

// ============================================
// FIX: Export testemonials for backward compatibility
// ============================================
export const testemonials = testimonialsData;

// ============================================
// Default export for convenience
// ============================================
export default {
  companyInfo,
  navLinks,
  socialLinks,
  usefulLinks,
  heroContent,
  aboutContent,
  whyChooseData,
  servicesData,
  projectsData,
  projectStats,
  statsData,
  testimonialsData,
  testemonials,
  groupCompanies,
  certificationData,
};